// Not the package barrel: utils.ts pulls the AWS SSM and SNS clients in at
// module scope.
import {
    configureRegimeClient,
    getResolvedRegimeMappings
} from "@idwal/idwal-utilities/lib/regimeMappings";
import { getCurrentSessionIdToken } from "../queries/AuthToken";
import { RegimeMappingsForRisk } from "../utils/PscRiskGraphHelper";

let configured = false;

/**
 * getToken is a callback rather than a token so a refreshed session is picked
 * up on a retry.
 */
const configure = () => {
    if (configured) {
        return;
    }

    configureRegimeClient({
        baseUrl: process.env.REACT_APP_IDWAL_API_ENDPOINT ?? "",
        getToken: getCurrentSessionIdToken
    });

    configured = true;
};

/** Fetched once per session; the library holds the cache. */
export const getRegimeMappings = async (): Promise<RegimeMappingsForRisk> => {
    configure();

    return await getResolvedRegimeMappings();
};
